import { MobileTopicsDropdown, TopicsSidebar } from "../components/page-specific/Learning Center/TopicsSidebar/TopicsSidebar"
import React from "react"
import CtaSection from "../components/sections/CtaSection"
import Layout from "../components/global/Layout"
import LearningCenterHeader from "../components/page-specific/Learning Center/LearningCenterHeader/LearningCenterHeader"
import { graphql } from "gatsby"
import { queries } from "../breakpoints"
import styled from "styled-components";
import { capitalize, decideToShowSecondSwitch, buildTopicHierarchy, predefinedSortSubTopics } from './resourcesHelperFunctions';
import ResourceCenterHeader from "../components/global/ResourceCenterHeader/ResourceCenterHeader";
import LearningCenterBreadCrumbs from "../components/page-specific/Learning Center/LearningCenterBreadCrumbs/LearningCenterBreadCrumbs";


const ResourceIndex = ({ location, data }) => {

  const [activeAncestor, setActiveAncestor] = React.useState();
  const [breadCrumbLink, setBreadcrumbLink] = React.useState();
  const [resourceHierarchy, setResourceHierarchy] = React.useState(buildTopicHierarchy(data.allTopics.nodes));
  const [resourcesToDisplay, setResourcesToDisplay] = React.useState([]);
  const [activeTopic, setActiveTopic] = React.useState();
  const [directTopicParent, setDirectParentTopic] = React.useState();
  const [activeParentTopic, setActiveParentTopic] = React.useState();
  const [activeParentDescription, setActiveParentDescription] = React.useState();

  React.useEffect(() => {
    if (resourceHierarchy.length === 0) {
      setResourceHierarchy(buildTopicHierarchy(data.allTopics.nodes));
    }
  }, [location.search])

  React.useEffect(() => {
    let resourceText = location.search.toString(),
        specialChars = '%20&%20',
        charsValid = resourceText.indexOf( specialChars ),
        resourceType = '',
        params = '';

    if( charsValid > -1 ) {
      resourceText = resourceText.replace( specialChars, '+', resourceText );
    }


    params = new URLSearchParams( resourceText );
    resourceType = params.get( "resource_type" );
    if( charsValid > -1 ){
      resourceType = resourceType.toString().replace( " ", " & ", params.get( "resource_type" ) );
    }

    //console.log( 'Params::', params );
    if (resourceType !== '') {
      //changeTopic(capitalize(params.get("resource_type")));
      changeTopic(capitalize( resourceType), params.get('resource_parent'));
    }
  },[resourceHierarchy])

  const renderResources = () => {
    let render = []
    const renderTopics = (topics) => {
      let topicsArray = []
      topics.map(topic => {
        topicsArray.push(topic.name);
        return null;
      })
      return topicsArray.join(", ");
    }
    //console.log( "renderResources::::::", resourcesToDisplay );
    resourcesToDisplay.map((resource, i) => {
      //console.log("window.location.origin", window.location.origin);
      render.push(
          <ResourceItem style={resource.menuOrder && resource.menuOrder === 9999 ? { order: 99 } : {}} href={window.location.origin + resource.slug} key={i}>
          <div>
            <ResourceItemTitle>
              {resource.title}{arrowLink()}
            </ResourceItemTitle>
          </div>
        </ResourceItem>
      );
    });
    return render;
  }

  const changeTopic = (topicName, parentTopic = '') => {
      console.log( 'TopicName:', topicName );
      console.log( 'ParentTopic:', parentTopic );
    changeTopicAndResources( topicName, parentTopic );
  }



  const breadcrumbs = [
    {
      link: "/learning-center/",
      text: "Home",
      active: false
    }
  ];

  const getBreadcrumbs = () =>{
        let updatedBreadCrumbs = [];
        breadcrumbs.forEach( crumb => {
          updatedBreadCrumbs.push(crumb)
        } );

        updatedBreadCrumbs.push( {
          link: "/learning-center#-" + activeAncestor,
          text: activeAncestor,
          active: false
        });
        if( directTopicParent )
        updatedBreadCrumbs.push( {
          link: "/resources/?resource_parent=" + activeAncestor + '&resource_type=' + directTopicParent,
          text: directTopicParent,
          active: false
        });
        updatedBreadCrumbs.push( {
            link: null,
            text: activeTopic,
            active: true
        } );

        return updatedBreadCrumbs;
  };

  const arrowLink = () => {
    return (
        <svg width="15" height="16" viewBox="0 0 15 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.9914 5.92545L14.9754 7.89162L12.9914 9.86575L7.7194 15.1115L5.7434 13.1374C5.7434 13.1374 8.2634 10.8528 9.9834 9.30057H0.575397V6.5145H10.0154C8.3114 4.97022 5.7834 2.68565 5.7834 2.68565L7.7594 0.711517L12.9914 5.92545Z" fill="#6B6B83"/>
            </svg>
    )
  };
  function getDifference( a, b ) {
    return a.filter( element => {
      return !b.includes( element );
    } );
  }

  const noIndexMasterTopics = ( topicName, resourceHierarchy ) => {
    let defaultTopic = '',
        found = false;
    resourceHierarchy.every(
        (topic) => {
            let hasSubtopics = topic.subTopics.length > 0;
            if( capitalize( topic.name ) === capitalize( topicName ) ){
                if( hasSubtopics ){
                    let sortSubtopics = predefinedSortSubTopics( topicName, topic.subTopics, 'name' );
                    defaultTopic = sortSubtopics[0].name;
                }
            } else {
                if( hasSubtopics ){
                    defaultTopic = noIndexMasterTopics( topicName, topic.subTopics );
                }
            }

            found = defaultTopic !== '';

            return !found;
        }
    );
    return defaultTopic;
  }
    let level = 0;
  const changeTopicAndResources = ( topicName, masterTopicName ) => {

    let newResources = [],
        topicFoundName = topicName,
        topicAncestor = topicName,
        topicParent,
        topicDescription = '';

    // NO INDEX RESTRICT - Main topics: 'Enterprise Accounts / Self-Service Accounts ' / 'Employees'
    // Set default the first topic from the restricted main topic
    if( topicName === 'Enterprise Accounts' || topicName === 'Self-Service Accounts' || topicName === 'Employees' ){
        masterTopicName = ( topicName !== 'Employees' ? 'Corporate Administrator' : topicName );
        topicName = noIndexMasterTopics( topicName, resourceHierarchy );
        if( topicName === '' ){
            topicName = topicFoundName;
        }
    }

    resourceHierarchy.every( ( masterTopic ) => {
      let topicResourcesFound = false;

      if( masterTopicName != '' && masterTopicName != masterTopic.name ){
          return true;
      }

      if( capitalize( masterTopic.name ) === capitalize(topicName) && masterTopic.resources.length > 0 ){
          newResources.push( ...masterTopic.resources);
          topicResourcesFound = true;
          topicFoundName = masterTopic.name;
          topicDescription = masterTopic.description;
      } else {
        let searchSubTopics = searchForMatchingSubTopic( masterTopic.subTopics, topicName, masterTopic.name );
        topicResourcesFound = searchSubTopics.matchingTopic;
        if( searchSubTopics.matchingTopic ){
          newResources = searchSubTopics.resources;
          topicFoundName = searchSubTopics.subTopicName;
          topicAncestor = searchSubTopics.subTopicAncestor;
          topicParent = searchSubTopics.topicParent;
          topicDescription = searchSubTopics.description;
        }

      }

      if( topicResourcesFound ){
        setActiveAncestor( topicAncestor );
        setBreadcrumbLink( topicAncestor.replace(' ', '-').toLowerCase() );
        setActiveParentTopic( topicName );
        setActiveParentDescription( topicDescription );
        setResourcesToDisplay( newResources );
        if( topicParent ){
            setDirectParentTopic( capitalize( topicParent ) );
        }

        setActiveTopic( capitalize( topicName ) );
        return false;
      }
      return topicResourcesFound ? false : true;

    } );

  }

  const searchForMatchingSubTopic = ( subTopics, topicName, topicAncestor, topicParent ) => {
    let topicResources = [];
    let topicFound = false;
    let name = topicName;
    let result = { matchingTopic: false, resources: [], description: '', subTopicName: '', subTopicAncestor: topicAncestor };

      level++;

    if( capitalize( subTopics.name ) === capitalize( topicName ) ){
      result.resources.push( ...subTopics.resources );
      result.matchingTopic = true;
      topicFound = true;
      result.subTopicName = subTopics.name;
    } else if( subTopics.length > 0 ) {
      subTopics.every( ( topicInSubTopics ) => {
          if( capitalize( topicInSubTopics.name ) === capitalize( topicName ) ) {
          result.resources.push( ...topicInSubTopics.resources );
          result.matchingTopic = true;
          result.description = topicInSubTopics.description;
          result.topicParent = topicParent;
          topicFound = true;
          result.subTopicName = topicInSubTopics.name;
        } else{
          if( topicInSubTopics.subTopics && topicInSubTopics.subTopics.length > 0 ){
            result = searchForMatchingSubTopic( topicInSubTopics.subTopics, topicName, topicAncestor, topicInSubTopics.name  );
          }
        }

          return result.matchingTopic ? false : true;
      } );
    }

    return result;
  }

  const getSubTopicResources = ( topic ) =>{
    return ( topic.subTopics.length > 0 ) ? [ ...topic.resources] : [];
  };

  const topicIllustrations = {
      'Billing' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676498382/Corporate/ig27vvbprwupazwe2ecj.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503386/Corporate/hskegmna5i9oyhrsymm5.png'
      },
      'Company Details' : {
        'desktop' : 'https://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1677799060/Corporate/iszrrosye9dvbkowwtvv.png',
        'mobile' : 'https://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1677799095/Corporate/a22rsx9mlqslg0gwatzz.png'
      },
      'Contact Information' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676502375/Corporate/l6gjaylpx0nmndaovpgs.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503164/Corporate/o0sjs19hvx7kjlsykcoy.png'
      },
      /*'Contact Information - Employees' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676502375/Corporate/l6gjaylpx0nmndaovpgs.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503164/Corporate/o0sjs19hvx7kjlsykcoy.png'
      },*/

      'Getting Started': {
        'desktop': 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499456/Corporate/i9pfdtjpssdzfrczkelm.png',
        'mobile': 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503192/Corporate/yd8b4d37fejg9a0pssjt.png'
      },
      'Employees & Groups' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499424/Corporate/gtlhtkfw0yrb3vjpjh62.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503439/Corporate/htvrmob4hquuycrgfmhw.png'
      },
      'Meal Credit Settings' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499484/Corporate/jddpnixbt8hyszzug81k.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503500/Corporate/s9kdsualipzrnptllqlf.png'
      },
      'Orders' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499517/Corporate/v49n8ei2fym1exifx6vf.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503468/Corporate/gjg2dotysuk14gghumq7.png'
      },
      'Manage Your Account' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499677/Corporate/u1aujuxvf9qs3t28rhah.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503255/Corporate/kwolssjvxdxr04arwr5z.png'
      },
      'Setup Your Account' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499647/Corporate/ojllmvxnlpq6q8xgsh8u.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503291/Corporate/pgy98klphazwqcoowx15.png'
      },
      'Training Videos' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499712/Corporate/grdhxxnvybiidx9lp4w1.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503317/Corporate/qzwvirewbk3kqvyqzs3x.png'
      },
      'What Is A Self-Service Account' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499748/Corporate/eirr1pqewieuctsh955h.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503341/Corporate/dupenzee7jwmf6jhfcgj.png'
      },
      /*'Getting Started': {
        'desktop': 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676499456/Corporate/i9pfdtjpssdzfrczkelm.png',
        'mobile': 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503192/Corporate/yd8b4d37fejg9a0pssjt.png'
      },*/
      'Using Your Meal Credits' : {
        'desktop' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676502476/Corporate/yei6q8s7fxvmw570n3yb.png',
        'mobile' : 'http://media-cdn.grubhub.com/grubhub-marketing/image/upload/v1676503227/Corporate/axin6hrluqd7ck7pirml.png'
      }
  };

  const getIllustrationByTopic = () => {
    let illustration = {
          desktop: '',
          mobile: ''
        };
    if( topicIllustrations[activeParentTopic] !== undefined ) {
      illustration = topicIllustrations[activeParentTopic];
    }

    return illustration;
  }

  return (
      <Layout
          title={`Learning Center — ${activeParentTopic} — Grubhub Corporate`}
          description={"Questions about how a Grubhub corporate account works? Check out our resources center where we provide the information account admins and employees need including step-by-step instructions for using a corporate account."}
          utag_data={{
            pageGroup: "",
            subGroup: "",
            pageName: "",
            brand: "grubhub"
          }}
      >
      <ResourceCenterHeader
          headline="LEARNING CENTER"
          subheadline={activeParentTopic}//"Orders"
          description={activeParentDescription}//"Learn how to set up and place various order types and review order history"
          ctaLink="/get-started/"
          backgroundColor="#F9F9F9"
          searchSpacingTop="20px"
          rightSideIllustration={getIllustrationByTopic().desktop}
          mobileIllustration={getIllustrationByTopic().mobile}
      />
      <LearningCenterHeader
          breadcrumbs={getBreadcrumbs()}
          allTopics={data.allTopics}
          changeTopic={( topic ) => changeTopic( topic )}
          showSecondSwitch={decideToShowSecondSwitch( activeAncestor, resourceHierarchy ).shouldShow}
          secondSwitchTopics={decideToShowSecondSwitch( activeAncestor, resourceHierarchy ).secondSwitchTopics}
          activeAncestor={activeAncestor}
          activeParentTopic={activeParentTopic}
      />
      <ResourcesDashboard >
        <TopicsSidebar
            allTopics={data.allTopics}
            activeAncestor={activeAncestor}
            changeTopic={( topicName ) => changeTopic( topicName, activeParentTopic )}
            activeTopic={activeTopic}
            activeParentTopic={activeParentTopic}
            resourceHierarchy={resourceHierarchy}
            activeLinkArrow={arrowLink()}
        />
        <ResourcesContainer>
          <MobileTopicsDropdown
            allTopics={data.allTopics}
            activeAncestor={activeAncestor}
            changeTopic={(topicName) => changeTopic(topicName)}
            activeTopic={activeTopic}
          />
          {!resourcesToDisplay.length ? (
            // If there's no resources then display this
              <p>
                No resources found.
              </p>
            ) : (
              <>{renderResources()}</>
          )}
        </ResourcesContainer>
      </ResourcesDashboard>
      <CtaSection headline="Need to get in touch?" backgroundColor="#F9F9F9" />
    </Layout>
  )
}

export default ResourceIndex

export const accountAdminsQuery = graphql`
  query WordPressResources {
    allTopics: allWpTopic {
      nodes {
        id
        name
        description
        parentId
        resources {
          nodes {
            title
            date(formatString: "MMMM DD, YYYY")
            slug: uri
            menuOrder
            topics	{
            nodes {
              name
            }    
            }
          }
        }
      }
    }
  }
`

const ResourcesDashboard = styled.div`
  margin: 4rem 10vw 4rem;
  padding: 0 3rem 0 0;
  display:grid;
  grid-template-rows: auto auto;
  @media(${queries.min_break_md}){
    grid-template-columns: minmax(15%, 300px) auto
  }
  @media(${queries.max_break_sm}){
    padding: 0 1.5rem;
  }
`

const ResourcesContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 800px;
  border-top: 1px solid #D4D4DB; 
  margin-left: 2rem;
  @media (${queries.max_break_md}) {
    margin-left: 1rem;
    margin-right: 1rem;
  }
`

const ResourceTitle = styled.h2`
  color: var(--color-text);
  font-size: var(--fontSize-8);
  font-weight: bold;
  @media(${queries.max_break_md}){
    font-size: var(--fontSize-6);
  }
`

const ResourceSubTitle = styled.p`
  color: var(--color-text);
  font-size: var(--fontSize-3);
  margin-bottom: 25px;
  @media(${queries.max_break_md}){
    font-size: var(--fontSize-1);
  }
`

const ResourceItem = styled.a`
  position: relative;
  padding: 20px 20px 20px 0px;
  width:100%;
  display:flex;
  justify-content: space-between;
  align-items:center;
  border-radius: 3.29px;
  background-color: #ffffff;
  border-bottom: 1px solid #D4D4DB;

  @media(${queries.max_break_sm}){
    padding: 20px;
    flex-flow:column;
    align-items: flex-start;
  }
  &:first-of-type{    
    margin: 0; 
  }
  &:hover h4 > svg{
    transform: translateX( 10px );
  }
`

const ResourceItemTitle = styled.h4`
  font-family: var(--scandia-fontFamily);
  font-size: 20px;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: 0px;
  text-align: left;
  margin-bottom: 0;
  display: flex;
  align-items: center;
  
  svg{
    transition: all .24s;
    margin-left: 10px;
    & path{ 
      fill: var(--color-primary);
    }
  }
`

const ResourceItemTopic = styled.h4`
  color: var(--color-text);
  font-size: var(--fontSize-0);
  font-weight: 300;
  text-transform: uppercase;
`

const ResourceLink = styled.span`
  font-size: var(--fontSize-0);
  white-space: nowrap;
`
